<template>
  <div class="d-flex flex-column flex-grow-1">
    <div>
      <div class="display-1">RFQ</div>
      <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
    </div>

    <div>
      <v-row>
        <v-col cols="12" md="6" lg="6">
          <v-btn
            class="text-capitalize"
            color="primary"
            outlined
            depressed
            :to="`/dealer/rfq/${$route.params.id}`"
            >Back to Project Details</v-btn
          >
        </v-col>
        <v-col cols="12" md="6" lg="6"> </v-col>
      </v-row>

      <v-card>
        <v-card-text v-if="loading" class="text-center">
          <Loading />
          <strong>Loading RFQs...</strong>
        </v-card-text>
        <v-card-text v-if="!loading && !rfq">
          <strong>No Request found.</strong>
        </v-card-text>
        <v-card-text v-if="rfq && !loading">
          <v-tabs v-model="tab">
            <v-tab>Quote</v-tab>
            <v-tab>
              <template v-if="rfq.bids.length > 0">
                <v-badge :content="rfq.bids.length">
                  History
                </v-badge>
              </template>
              <template v-else>
                History
              </template>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <Quotes :rfq="rfq" @refresh="getRFQ" />
            </v-tab-item>
            <v-tab-item>
              <History :rfq="rfq" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/common/Loading";
import Quotes from "@/components/rfq/dealer/Quotes";
import History from "@/components/rfq/dealer/History";
export default {
  components: {
    Loading,
    Quotes,
    History
  },
  created() {
    this.getRFQ();
  },
  methods: {
    getRFQ() {
      const payload = {
        id: this.$route.params.id
      };

      this.loading = true;
      this.$store
        .dispatch("rfq/getDealerRFQById", payload)
        .then(resp => {
          this.rfq = { ...resp };
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  data() {
    return {
      tab: 0,
      loading: false,
      rfq: null,
      breadcrumbs: [
        {
          text: "Login",
          disabled: true
        },
        {
          text: "Project Details",
          to: `/dealer/rfq/${this.$route.params.id}`
        },
        {
          text: "Quotes"
        }
      ]
    };
  }
};
</script>
